import script from "./ContextDispositionsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextDispositionsTab.vue?vue&type=script&setup=true&lang=js"

import "./ContextDispositionsTab.vue?vue&type=style&index=0&id=73c35553&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c35553"]])

export default __exports__